module.exports = __webpack_public_path__ + "img/NE.208e303c.svg";